/**
 * Clients sometimes flag jobs inside the title, e.g. "[Urgent] Logo design".
 * Flags are shown as badges next to the title rather than as raw text.
 *
 * @param {string} title
 * @returns {{ text: string, flags: string[] }}
 */
export function parseTitleFlags(title = '') {
  const flags = [];
  const text = title
    .replace(/\[([^[\]]+)\]/g, (match, flag) => {
      const label = flag.trim();
      if (label) {
        flags.push(label);
      }
      return '';
    })
    .replace(/\s{2,}/g, ' ')
    .trim();

  return { text: text || title, flags };
}

/**
 * @param {string[]} flags
 * @returns {boolean}
 */
export function hasUrgentFlag(flags = []) {
  return flags.some((flag) => flag.toLowerCase() === 'urgent');
}
